module.exports = __webpack_public_path__ + "static/img/bc-gtbxz.fc2994e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-gtbxz.png
// module id = eubD
// module chunks = 0